/**
 * Adiciona evento no dataLayerGC para o GA
 */
function sendGAEvent(category, action, label) {
  var eventPayload = {
    action: action,
    category: category,
    event: 'GAEvent',
    label: label
  };

  if (window.gtag) {
    window.dataLayerGC.push(eventPayload);
    window.dataLayerCrossTracking.push(eventPayload);
  } else {
    console.log('Google Analytics event trigged -->', eventPayload);
  }
}

function sendGAEventWithMetadata(eventPayload) {
  if (!eventPayload.hasOwnProperty('event')) {
    Object.assign(eventPayload, { event: 'GAEvent' });
  }

  if (window.gtag) {
    window.dataLayerGC.push(eventPayload);
    window.dataLayerCrossTracking.push(eventPayload);
  } else {
    console.log('Google Analytics event trigged -->', eventPayload);
  }
}
